// extracted by mini-css-extract-plugin
export default {"list":"TaskList_list__cbetF","warning":"TaskList_warning__H4Pq4"};